package pl.decks.chartjs.model

internal interface JSEnum {
    val jsValue: String

    fun toChartJs() : dynamic = jsValue.asDynamic()
}
